import { gql } from '@apollo/client'

export const PLAN_TYPE_CREATE_MUTATION = gql`
  mutation PLAN_TYPE_CREATE_MUTATION($planType: PlanTypeCreateInput!) {
    planTypeCreate(planType: $planType) {
      ok
    }
  }
`

export const PLAN_TYPE_UPDATE_MUTATION = gql`
  mutation PLAN_TYPE_UPDATE_MUTATION($id: ID!, $planType: PlanTypeUpdateInput!) {
    planTypeUpdate(id: $id, planType: $planType) {
      ok
    }
  }
`

export const PLAN_TYPE_DELETE_MUTATION = gql`
  mutation PLAN_TYPE_DELETE_MUTATION($id: ID!) {
    planTypeDelete(id: $id) {
      ok
    }
  }
`
